import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CallService } from '../../../services/call.service';

@Component({
  selector: 'app-admin-call-center',
  templateUrl: './admin-call-center.component.html',
  styleUrls: ['./admin-call-center.component.scss']
})
export class AdminCallCenterComponent implements OnInit {
  callState$ = this.callService.callState$;
  isAvailable = false;

  constructor(
    public callService: CallService,
    private router: Router
  ) {}

  ngOnInit(): void {
    const role = localStorage.getItem('role');
    if (role !== 'admin') {
      this.router.navigate(['/dashboard']);
    }
  }

  toggleAvailability(): void {
    const adminId = localStorage.getItem('managerId') || '';
    const role = localStorage.getItem('role') || '';
    const name = localStorage.getItem('name') || 'Admin';

    if (this.isAvailable) {
      this.callService.joinSupport(adminId, role, name);
    } else {
      this.callService.leaveSupport();
    }
  }
}
